/* eslint-disable no-shadow */
/* eslint-disable max-nested-callbacks */
/* eslint-disable max-len */

import firebase from '../firebase'

import {
  LOGIN_SUCCESS,
  SIGNOUT_SUCCESS,
  SHOW_TOAST,
  ERROR,
  INFO,
  USER_LOGGED_IN,
  GLP_LOGGED_PROFILE,
  GLP_LOGGED_COMPANY,
  APP_TYPE,
  WARNING,
  FB_URL
} from './types'
import { loggedInProfileActions } from './loggedInProfileActions'

import { DATE_FORMAT } from '../../utils/date_format_utils'
//import { sendWhatsAppOTP as sendWhatsAppOTPService, formatPhoneNumber, validatePhoneNumber, clearTwilioRateLimit } from '../../services/whatsappService'
import { checkDeviceTrust, trustDevice, updateDeviceLastUsed, untrustDevice } from '../../utils/deviceTrust'
import axios from 'axios'
import * as OTPAuth from 'otpauth';
import firebaseCompat from '../../utils/firebaseCompat';   // ← NEW LINE

require('firebase/auth')
// authActions.js:279
// black signInWithEmailAndPassword
// black signUpNewUsers

// Global flag to prevent auth state changes during credential validation
let isValidatingCredentials = false;

// Global flag to prevent auth state changes during Google auth
let isGoogleAuthInProgress = false;
// Track current Google auth mode: 'idle' | 'login' | 'signup'
let googleAuthMode = 'idle';

// Simplified login: always perform direct email/password login with no WhatsApp OTP step
export const signInWithEmailAndPassword = credentials => {
  console.log('[signInEmailEnhanced] 1.3:', credentials);
  return async (dispatch, getState) => {
    return await dispatch(signInWithEmailAndPasswordDirect(credentials));
  }
}

export const signInWithEmailAndPasswordx = credentials => {
  return async (dispatch, getState) => {
    await firebase.auth
      .signInWithEmailAndPassword(credentials.username, credentials.userpassword)
      .then(auth => {
        const userobj = {
          uid: auth.user.uid,
          displayName: auth.user.displayName,
          email: auth.user.email,
          emailVerified: auth.user.emailVerified,
          refreshToken: auth.user.refreshToken,
          metadata: auth.user.metadata,
          selectClub: auth.user.selectClub,
          companyID: getCompanyID(auth.user.email)
        }

        // localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));
        // loggedInProfileActions(userobj.uid);
        // dispatch({ type: LOGIN_SUCCESS, auth: userobj });

        let userLoginData = {
          uid: auth.user.uid,
          name: auth.user.displayName,
          email: auth.user.email,
          dateRegistered: Date.now(),
          clickType: 'lastlogin'
        }

        // Do not store login locally until we confirm the user exists in our system

        firebase.database
          .ref(`/user/${userobj.uid}`)
          .once('value')
          .then(data => {
            let isUser = data.val()

            if (isUser) {
              firebase.database.ref('user-lastlogin').push(userLoginData)
              // Use authStateChanged to handle OTP verification
              dispatch(authStateChanged(userobj))
            } else {
              // get date and time
              let timeInMs = Date.now()
              let datetime = new Date(timeInMs)
              // format date
              datetime = DATE_FORMAT.type(datetime, 'BADGE')

              let userID = firebase.database
                .ref()
                .child('users')
                .push().key
              var data = {
                // companyID: "-LjW7UI7e0uUikYrw-Vj",
                // companyName: "Thinklead Ecosystem",
                dateRegistered: timeInMs,
                email: auth.user.email,
                firstName: auth.user.displayName,
                lastName: '',
                password: '',
                stringDateRegistered: datetime,
                userDescription: 'Public Contributor',
                uid: auth.user.uid,
                userID: userID,
                userType: 3,
                inviteSent: true,
                companyID_userType: auth.user.selectClub + '_3',
                photoURL: auth.user.photoURL
                // companyID: params.selectClub,
                // companyName: params.clubName
              }
  
              // Write the new rating data
              let updates = {}
              updates['/users/' + userID] = data
              updates['/user/' + auth.user.uid] = data

              firebase.database.ref().update(updates, function (error) {
                if (error) {
                  // The write failed...
                  firebase.auth.signOut().then(() => {
                    localStorage.removeItem(USER_LOGGED_IN)
                    localStorage.removeItem(GLP_LOGGED_PROFILE)
                    localStorage.removeItem(GLP_LOGGED_COMPANY)
                    sessionStorage.removeItem('reAuthRequired');
                    sessionStorage.removeItem('cachedTotpSecret'); 

                    dispatch({
                      type: SHOW_TOAST,
                      variant: ERROR,
                      message: error.message
                    })
                    return
                  })
                } else {
                  firebase.database.ref('user-lastlogin').push(userLoginData)
                  // Use authStateChanged to handle OTP verification
                  dispatch(authStateChanged(userobj))
                  return
                }
              })
            }
          })
          .catch(function (error) {
            firebase.auth.signOut().then(() => {
              localStorage.removeItem(USER_LOGGED_IN)
              localStorage.removeItem(GLP_LOGGED_PROFILE)
              localStorage.removeItem(GLP_LOGGED_COMPANY)
              sessionStorage.removeItem('reAuthRequired');
           sessionStorage.removeItem('cachedTotpSecret'); 
              dispatch({
                type: SHOW_TOAST,
                variant: ERROR,
                message: error.message
              })
              return
            })
          })
      })
      .catch(err => {
        localStorage.removeItem(USER_LOGGED_IN)
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: err.message })
      })
  }
}

function splitNameFirst(fullnamea) {
  let fullNameb = fullnamea.split(' ')
  let firstName = fullNameb[0]
  return firstName
}

function splitNameLast(fullnamea) {
  let fullNameb = fullnamea.split(' ')
  let firstName = fullNameb[0]
  let lastName = fullNameb[fullNameb.length - 1]
  return lastName
}
export const signInWithGoogle = signupData => {
  // Handle both old format (just selectClub string) and new format (signup data object)
  const isSignup = !!(signupData && typeof signupData === 'object' && signupData.isSignup);
  const selectClubb = (signupData && typeof signupData === 'object' && signupData.selectClub)
    || (typeof signupData === 'string' ? signupData : undefined);

  let provider = new firebase.auth_.GoogleAuthProvider();

  return async (dispatch, getState) => {
    isGoogleAuthInProgress = true;
    googleAuthMode = isSignup ? 'signup' : 'login';

    try {
      if (signupData && signupData.loginEmail) {
        provider.setCustomParameters({ login_hint: signupData.loginEmail });
      }
    } catch (_) {}

  try {
    await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);  // ← ADD
    const auth = await firebase.auth.signInWithPopup(provider);

      let userobj = {
        uid: auth.user.uid,
        displayName: auth.user.displayName,
        email: auth.user.email,
        emailVerified: auth.user.emailVerified,
        refreshToken: auth.user.refreshToken,
        metadata: auth.user.metadata,
        photoURL: auth.user.photoURL || '',
        accessToken: auth.credential.accessToken
      };

      // ===================================================================
      // === EMAIL CONFIRMATION CHECK FOR GOOGLE LOGIN === COMMENT OUT LOCAL HOST
      // ===================================================================
      const confirmationStatus = await dispatch(checkEmailConfirmationStatus(auth.user.email));

      if (confirmationStatus !== true) {
        // Email not confirmed via your email-link flow → block Google login
        await firebase.auth.signOut();
        sessionStorage.removeItem('reAuthRequired');
        localStorage.removeItem(USER_LOGGED_IN);
        localStorage.removeItem(GLP_LOGGED_PROFILE);
        localStorage.removeItem(GLP_LOGGED_COMPANY);
        sessionStorage.removeItem('cachedTotpSecret'); 
        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: 'Please confirm your email first using the link sent to your inbox before signing in with Google.'
        });

        isGoogleAuthInProgress = false;
        googleAuthMode = 'idle';
        return;
      }

      console.log('[signInWithGoogle] Email confirmed — proceeding');
      // ===================================================================

      let userLoginData = {
        uid: auth.user.uid,
        name: auth.user.displayName,
        email: auth.user.email,
        dateRegistered: Date.now(),
        clickType: 'lastlogin'
      };

      localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));

      const dataSnapshot = await firebase.database.ref(`/user/${userobj.uid}`).once('value');
      let isUser = dataSnapshot.val();

      if (isUser) {
        // Existing user → normal login
        localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));
        await firebase.database.ref('user-lastlogin').push(userLoginData);

        dispatch({ type: LOGIN_SUCCESS, auth: userobj });
        dispatch(loggedInProfileActions(userobj.uid));
        dispatch({ type: GLP_LOGGED_COMPANY });

        try { dispatch(consumeInviteIfAny(userobj.uid)); } catch (_) {}
  // ---- Telegram account linking ----
   const pendingToken = localStorage.getItem("pendingLinkToken")
  || new URLSearchParams(window.location.search).get("linkToken");
    //console.log('signInDirect: pendingToken =', pendingToken);

  if (pendingToken) {
    localStorage.removeItem("pendingLinkToken");
    try {
      const linkRes = await axios.post(`${FB_URL}/m126-completeTelegramLink`, {
        token: pendingToken,
        firebaseUid: auth.user.uid,
      });
      if (linkRes.data?.success) {
        console.log('Telegram account linked successfully');
      } else {
        console.error('Telegram link error:', linkRes.data);
      }
    } catch (err) {
      console.error('Telegram link failed:', err);
    }
  }
  // ----------------------------------
        isGoogleAuthInProgress = false;
        googleAuthMode = 'idle';
      } else {
        if (isSignup) {
          // New user + signup mode → create account
          let timeInMs = Date.now();
          let datetime = new Date(timeInMs);
          datetime = DATE_FORMAT.type(datetime, 'BADGE');

          let userID = firebase.database.ref().child('users').push().key;

          var data = {
            companyID: selectClubb || '-NRbTwxbqFLepk62Eq6M',
            companyName: isSignup && signupData.clubName ? signupData.clubName : 'Me-Vision Academy',
            dateRegistered: timeInMs,
            email: auth.user.email,
            firstName: splitNameFirst(auth.user.displayName || ''),
            lastName: splitNameLast(auth.user.displayName || ''),
            password: '',
            stringDateRegistered: datetime,
            userDescription: isSignup ? 'Standard User' : 'Public Contributor',
            uid: auth.user.uid,
            userID: userID,
            userType: 8,
            inviteSent: true,
            companyID_userType: (selectClubb || '-NRbTwxbqFLepk62Eq6M') + '_8',
            photoURL: auth.user.photoURL,
            points: 1,
            feedback: 0,
            feedbackOn: true,
            gfeedbackOn: true,
            agreeTCs: isSignup && signupData.agreeTCs ? signupData.agreeTCs : false,
            department: isSignup && signupData.department ? signupData.department : 'Not Specified',
            position: isSignup && signupData.position ? signupData.position : 'Not Specified',
            nationality: isSignup && signupData.nationality ? signupData.nationality : 'Not Specified',
            defaultSecurityLevel: 'level1',
            receiveWhatsAppSecurity: false
          };

          let updates = {};
          updates['/users/' + userID] = data;
          updates['/user/' + auth.user.uid] = data;

            var res = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                    updates: updates, //user wallet address                       
                }
              })

          if (res.data || res.data.success === true) {
              localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));
              await firebase.database.ref('user-lastlogin').push(userLoginData);

              dispatch({ type: LOGIN_SUCCESS, auth: userobj });
              dispatch(loggedInProfileActions(userobj.uid));
              dispatch({ type: GLP_LOGGED_COMPANY });

              try { dispatch(consumeInviteIfAny(userobj.uid)); } catch (_) {}

              isGoogleAuthInProgress = false;
              googleAuthMode = 'idle';       
           }
          else {
              await firebase.auth.signOut();
              localStorage.removeItem(USER_LOGGED_IN);
              localStorage.removeItem(GLP_LOGGED_PROFILE);
              localStorage.removeItem(GLP_LOGGED_COMPANY);
              sessionStorage.removeItem('reAuthRequired');
              sessionStorage.removeItem('cachedTotpSecret'); 

              dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Signup failed. Please try again.' });
              isGoogleAuthInProgress = false;
              googleAuthMode = 'idle';
          }; 

          // firebase.database.ref().update(updates, async (error) => {
          //   if (error) {
          //     await firebase.auth.signOut();
          //     localStorage.removeItem(USER_LOGGED_IN);
          //     localStorage.removeItem(GLP_LOGGED_PROFILE);
          //     localStorage.removeItem(GLP_LOGGED_COMPANY);

          //     dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Signup failed. Please try again.' });
          //     isGoogleAuthInProgress = false;
          //     googleAuthMode = 'idle';
          //   } else {
          //     localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));
          //     await firebase.database.ref('user-lastlogin').push(userLoginData);

          //     dispatch({ type: LOGIN_SUCCESS, auth: userobj });
          //     dispatch(loggedInProfileActions(userobj.uid));
          //     dispatch({ type: GLP_LOGGED_COMPANY });

          //     try { dispatch(consumeInviteIfAny(userobj.uid)); } catch (_) {}

          //     isGoogleAuthInProgress = false;
          //     googleAuthMode = 'idle';
          //   }
          // });
        } else {
          // Existing Google auth but no account + not in signup mode → block
          (async () => {
            try {
              const cu = firebase.auth.currentUser;
              if (cu) await cu.delete();
            } catch (_) {}
            await firebase.auth.signOut();
            sessionStorage.removeItem('reAuthRequired');
            localStorage.removeItem(USER_LOGGED_IN);
            localStorage.removeItem(GLP_LOGGED_PROFILE);
            localStorage.removeItem(GLP_LOGGED_COMPANY);
              sessionStorage.removeItem('cachedTotpSecret');
            dispatch({
              type: SHOW_TOAST,
              variant: WARNING,
              message: 'Google sign-in is restricted. Your email is not registered on this system. Go to CREATE ACCOUNT → Sign up with Google.'
            });

            isGoogleAuthInProgress = false;
            googleAuthMode = 'idle';
          })();
        }
      }
    } catch (error) {
      isGoogleAuthInProgress = false;
      googleAuthMode = 'idle';

      localStorage.removeItem(USER_LOGGED_IN);

      dispatch({ type: SHOW_TOAST, variant: ERROR, message: error.message });
    }
  };
};

//  export const signInWithGoogle = signupData => {
//   // Handle both old format (just selectClub string) and new format (signup data object)
//   const isSignup = !!(signupData && typeof signupData === 'object' && signupData.isSignup);
//   const selectClubb = (signupData && typeof signupData === 'object' && signupData.selectClub)
//     || (typeof signupData === 'string' ? signupData : undefined);

//  let provider = new firebase.auth_.GoogleAuthProvider()

//   return async (dispatch, getState) => {
//     // Always set flag while Google auth flow is in progress
    
//     isGoogleAuthInProgress = true;
//     googleAuthMode = isSignup ? 'signup' : 'login';

//     // If loginEmail is provided (from SignIn), set login_hint to reduce accidental new-account creation
//     try {
//       if (signupData && signupData.loginEmail) {
//         provider.setCustomParameters({ login_hint: signupData.loginEmail });
//       }
//     } catch (_) {}

    
//     await firebase.auth
//       .signInWithPopup(provider)
//       .then(function (auth) {
        
        
//         let userobj = {
//           uid: auth.user.uid,
//           displayName: auth.user.displayName,
//           email: auth.user.email,
//           emailVerified: auth.user.emailVerified,
//           refreshToken: auth.user.refreshToken,
//           metadata: auth.user.metadata,
//           photoURL: auth.user.photoURL || '',
//           accessToken: auth.credential.accessToken
//         }
        
//         let userLoginData = {
//           uid: auth.user.uid,
//           name: auth.user.displayName,
//           email: auth.user.email,
//           dateRegistered: Date.now(),
//           clickType: 'lastlogin'
//         }

//         localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj))

//         firebase.database
//           .ref(`/user/${userobj.uid}`)
//           .once('value')
//           .then(data => {
//             let isUser = data.val()

//         if (isUser) {
//               // Persist session only for existing users
//               localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj))
//               // Account exists → treat both signup/login as login
              
//               firebase.database.ref('user-lastlogin').push(userLoginData)
//               dispatch({ type: LOGIN_SUCCESS, auth: userobj })
//               dispatch(loggedInProfileActions(userobj.uid))
//               dispatch({ type: GLP_LOGGED_COMPANY })
//               // Apply invite if one was captured from URL
//               try { dispatch(consumeInviteIfAny(userobj.uid)); } catch (_) {}
//               isGoogleAuthInProgress = false;
//           googleAuthMode = 'idle';
//             } else {
//           if (isSignup) {
            
//             // get date and time
//             let timeInMs = Date.now()
//             let datetime = new Date(timeInMs)
//             // format date
//             datetime = DATE_FORMAT.type(datetime, 'BADGE')

//             let userID = firebase.database
//               .ref()
//               .child('users')
//               .push().key

//             // Create user data structure
//             var data = {
//               companyID: selectClubb || '-NRbTwxbqFLepk62Eq6M',
//               companyName: isSignup && signupData.clubName ? signupData.clubName : 'Me-Vision Academy',
//               dateRegistered: timeInMs,
//               email: auth.user.email,
//               firstName: splitNameFirst(auth.user.displayName || ''),
//               lastName: splitNameLast(auth.user.displayName || ''),
//               password: '',
//               stringDateRegistered: datetime,
//               userDescription: isSignup ? 'Standard User' : 'Public Contributor',
//               uid: auth.user.uid,
//               userID: userID,
//               userType: 8,
//               inviteSent: true,
//               companyID_userType: (selectClubb || '-NRbTwxbqFLepk62Eq6M') + '_8',
//               photoURL: auth.user.photoURL,
//               points: 1,
//               feedback: 0,
//               feedbackOn: true,
//               gfeedbackOn: true,
//               agreeTCs: isSignup && signupData.agreeTCs ? signupData.agreeTCs : false,
//               department: isSignup && signupData.department ? signupData.department : 'Not Specified',
//               position: isSignup && signupData.position ? signupData.position : 'Not Specified',
//               nationality: isSignup && signupData.nationality ? signupData.nationality : 'Not Specified',
//               defaultSecurityLevel: 'level1',
//               receiveWhatsAppSecurity: false
//             }

            

//             let updates = {}
//             updates['/users/' + userID] = data
//             updates['/user/' + auth.user.uid] = data

            
            
//             firebase.database.ref().update(updates, function (error) {
//               if (error) {
                
//                 firebase.auth.signOut().then(() => {
//                   localStorage.removeItem(USER_LOGGED_IN)
//                   localStorage.removeItem(GLP_LOGGED_PROFILE)
//                   localStorage.removeItem(GLP_LOGGED_COMPANY)

//                   dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Signup failed. Please try again.' })
//                   isGoogleAuthInProgress = false;
//                   googleAuthMode = 'idle';
//                   return
//                 })
//               } else {
                
//                 localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj))
//                 firebase.database.ref('user-lastlogin').push(userLoginData)
//                 dispatch({ type: LOGIN_SUCCESS, auth: userobj })
//                 dispatch(loggedInProfileActions(userobj.uid))
//                 dispatch({ type: GLP_LOGGED_COMPANY })
//                 // Apply invite for new Google signups
//                 try { dispatch(consumeInviteIfAny(userobj.uid)); } catch (_) {}
//                 isGoogleAuthInProgress = false;
//                 googleAuthMode = 'idle';
//                 return
//               }
//             })
//           } else {
//             // Policy: Do NOT auto-create accounts via Google login.
            
//             (async () => {
//               try {
//                 const cu = firebase.auth.currentUser;
//                 if (cu) {
//                   await cu.delete(); // remove the accidentally created Firebase Auth identity
//                 }
//               } catch (delErr) {
                
//               }
//               try { await firebase.auth.signOut(); } catch (_) {}

//               localStorage.removeItem(USER_LOGGED_IN)
//               localStorage.removeItem(GLP_LOGGED_PROFILE)
//               localStorage.removeItem(GLP_LOGGED_COMPANY)

//               dispatch({
//                 type: SHOW_TOAST,
//                 variant: WARNING,
//                 message: 'Google sign-in is restricted. Your email is not registered on this system. Go to CREATE ACCOUNT → Sign up with Google.'
//               })
//               isGoogleAuthInProgress = false;
//               googleAuthMode = 'idle';
//             })();
//           }
//             }
//           })
//           .catch(function (error) {
//             // Clear flag on error
//             isGoogleAuthInProgress = false;
//         googleAuthMode = 'idle';
            
            
//             firebase.auth.signOut().then(() => {
//               localStorage.removeItem(USER_LOGGED_IN)
//               localStorage.removeItem(GLP_LOGGED_PROFILE)
//               localStorage.removeItem(GLP_LOGGED_COMPANY)

//               dispatch({
//                 type: SHOW_TOAST,
//                 variant: ERROR,
//                 message: error.message
//               })
//               return
//             })
//           })
//       })
//       .catch(function (error) {
//         // Clear flag on error
//         isGoogleAuthInProgress = false;
//         googleAuthMode = 'idle';
        
        
//         localStorage.removeItem(USER_LOGGED_IN)
//         dispatch({ type: SHOW_TOAST, variant: ERROR, message: error.message })
//       })
//   }
// }

export const resetUserPassword = params => {
  return async (dispatch, getState) => {
    await firebase.auth
      .sendPasswordResetEmail(params.email)
      .then(function () {
        dispatch({
          type: SHOW_TOAST,
          variant: INFO,
          message: 'A password reset link has been mailed to your email account.'
        })
      })
      .catch(function (error) {
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: error.message })
      })
  }
}

const getCompanyID = email => {
  let compID
  // ------------------------USERS
  firebase.database
    .ref('users').orderByChild('email').equalTo(email)
    .once('value').then((snapshot) => {
      snapshot.forEach((subSnapshot) => {
        let companyID = subSnapshot.companyID
        if (companyID) {
          compID = companyID
        }
      })
    })
  // ------------------------USER
  firebase.database
    .ref('user').orderByChild('email').equalTo(email)
    .once('value').then((snapshot) => {
      snapshot.forEach((subSnapshot) => {
        let companyID = subSnapshot.companyID
        if (companyID) {
          compID = companyID
        }
      })
    })
  // ------------------------SUBSCRIBED
  firebase.database
    .ref('subscribed').orderByChild('email').equalTo(email)
    .once('value').then((snapshot) => {
      snapshot.forEach((subSnapshot) => {
        let companyID = subSnapshot.companyID
        if (companyID) {
          compID = companyID
        }
      })
    })
  if (compID) {
    return compID
  }
}
//////////////////////////////////////////////////////////////////////////////////////
export const signUpNewUsers = (params) => {
  return async (dispatch) => {
    try {
      // Send to backend
      await axios.post(`${FB_URL}/m118-freshsignup`, params);
      const { email, password, pendingLinkToken } = params.params;
      let userCredential;
      try {
        userCredential = await firebaseCompat.auth().signInWithEmailAndPassword(email, password);
      } catch (signInErr) {
        if (signInErr.code === 'auth/wrong-password' || signInErr.code === 'auth/user-not-found') {
          console.log('User pre-authenticated — skipping sign-in step');
          dispatch({ type: LOGIN_SUCCESS, auth: { email } });
          dispatch({ type: SHOW_TOAST, variant: 'success', message: 'Account setup complete! Please log in.' });
          return;
        }
        throw signInErr;
      }
      const user = userCredential.user;
      if (window.APP_TYPE === 'PUBLIC') {
        try {
          await user.sendEmailVerification({ url: window.location.origin });
          dispatch({ type: SHOW_TOAST, variant: 'success', message: 'Signed up! Check your email.' });
        } catch (_) {
          dispatch({ type: SHOW_TOAST, variant: 'info', message: 'Signed up (no verification email)' });
        }
      }
      firebaseCompat.database().ref('user-lastlogin').push({
        uid: user.uid,
        name: user.displayName || `${params.firstName} ${params.lastName}`,
        email: user.email,
        dateRegistered: Date.now(),
        clickType: 'lastlogin',
      });
      dispatch({ type: LOGIN_SUCCESS, auth: user });
      dispatch({ type: GLP_LOGGED_COMPANY });
      // ---- Telegram account linking after signup ----
      const linkToken = pendingLinkToken || localStorage.getItem('pendingLinkToken');
      if (linkToken && user.uid) {
        localStorage.removeItem('pendingLinkToken');
        axios.post(`${FB_URL}m126-completeTelegramLink`, {
          token: linkToken,
          firebaseUid: user.uid,
        })
        .then(res => console.log('signUpNewUsers: Telegram link result =', res.data))
        .catch(err => console.error('signUpNewUsers: Telegram link error =', err));
      }
      // ------------------------------------------------
    } catch (error) {
      console.error('Signup error:', error);
      let message = error.response?.data?.error || error.message || 'Signup failed';
      dispatch({ type: SHOW_TOAST, variant: ERROR, message });
      firebaseCompat.auth().signOut().catch(() => {});
      sessionStorage.removeItem('reAuthRequired');
      sessionStorage.removeItem('cachedTotpSecret');
    }
  };
};
//DEFAULT SIGNUPUSERS FUNCTION/////////////////////////////////////////////////////////
// export const signUpNewUsers = (params) => {
//   return async (dispatch) => {
//     try {
//       // Send to backend (which now reuses existing user if pre-authenticated)
//       await axios.post(`${FB_URL}/m118-freshsignup`, params);

//       const { email, password } = params.params;

//       // Attempt sign-in — if user was pre-authenticated, this may fail if password doesn't match
//       let userCredential;
//       try {
//         userCredential = await firebaseCompat.auth().signInWithEmailAndPassword(email, password);
//       } catch (signInErr) {
//         if (signInErr.code === 'auth/wrong-password' || signInErr.code === 'auth/user-not-found') {
//           // User likely pre-authenticated via link — try re-auth or skip sign-in
//           console.log('User pre-authenticated — skipping sign-in step');
//           // Optionally dispatch success anyway if backend confirmed creation
//           dispatch({ type: LOGIN_SUCCESS, auth: { email } }); // minimal auth object
//           dispatch({ type: SHOW_TOAST, variant: 'success', message: 'Account setup complete! Please log in.' });
//           return;
//         }
//         throw signInErr;
//       }

//       const user = userCredential.user;

//       if (window.APP_TYPE === 'PUBLIC') {
//         try {
//           await user.sendEmailVerification({ url: window.location.origin });
//           dispatch({ type: SHOW_TOAST, variant: 'success', message: 'Signed up! Check your email.' });
//         } catch (_) {
//           dispatch({ type: SHOW_TOAST, variant: 'info', message: 'Signed up (no verification email)' });
//         }
//       }

//       // Log last login, etc.
//       firebaseCompat.database().ref('user-lastlogin').push({
//         uid: user.uid,
//         name: user.displayName || `${params.firstName} ${params.lastName}`,
//         email: user.email,
//         dateRegistered: Date.now(),
//         clickType: 'lastlogin',
//       });

//       dispatch({ type: LOGIN_SUCCESS, auth: user });
//       dispatch({ type: GLP_LOGGED_COMPANY });

//     } catch (error) {
//       console.error('Signup error:', error);
//       let message = error.response?.data?.error || error.message || 'Signup failed';
//       dispatch({ type: SHOW_TOAST, variant: ERROR, message });
//       firebaseCompat.auth().signOut().catch(() => {});
//     }
//   };
// };
///////////////////////////////////////////////////////////////////////////////////////


export const authStateChanged = userobj => {
  return async (dispatch, getState) => {
     loggedInProfileActions(userobj.uid);
    
    // Complete login directly - no post-login WhatsApp verification
    dispatch({ type: LOGIN_SUCCESS, auth: userobj })
    dispatch({ type: GLP_LOGGED_COMPANY })

    // After login, if there is an invite stored, consume it
    try {
      if (typeof window !== 'undefined') {
        const raw = localStorage.getItem('INVITE_DATA');
        if (raw) {
          const invite = JSON.parse(raw);
          if (invite && invite.companyID) {
            await dispatch(consumeInviteIfAny(userobj.uid, invite));
          }
        }
      }
    } catch (_) {}
  }
}

// Consume invite: assign company to new/returning user and auto-follow inviter if provided
export const consumeInviteIfAny = (uid, invite) => {
  return async (dispatch, getState) => {
    try {
      let localInvite = invite;
      if (!localInvite && typeof window !== 'undefined') {
        try { localInvite = JSON.parse(localStorage.getItem('INVITE_DATA') || 'null'); } catch (_) { localInvite = null; }
      }
      const { companyID } = localInvite || {};
      let inviterUID = localInvite && localInvite.inviterUID ? localInvite.inviterUID : null;
      if (!companyID || !uid) return;

      // Load user profile (retry a few times to allow fresh signups to propagate)
      let userSnap = await firebase.database.ref(`/user/${uid}`).once('value');
      let user = userSnap.val() || {};
      let retries = 0;
      while ((!user || !user.userID) && retries < 5) {
        await new Promise(r => setTimeout(r, 200));
        userSnap = await firebase.database.ref(`/user/${uid}`).once('value');
        user = userSnap.val() || {};
        retries++;
      }

      // If already in this company, just clear invite and return
      if (user.companyID === companyID) {
        try { console.log('[INVITE] already in company, skipping follow'); } catch (_) {}
        localStorage.removeItem('INVITE_DATA');
        return;
      }

      // Basic assignment defaults
      const userType = user.userType || 8; // keep existing or default standard user
      const updates = {};
      // mirror in both tables
      if (user.userID) {
        updates[`/users/${user.userID}/companyID`] = companyID;
        updates[`/users/${user.userID}/companyID_userType`] = `${companyID}_${userType}`;
      }
      updates[`/user/${uid}/companyID`] = companyID;
      updates[`/user/${uid}/companyID_userType`] = `${companyID}_${userType}`;

      try { console.log('[INVITE] assigning company', { uid, companyID }); } catch (_) {}
      await firebase.database.ref().update(JSON.parse(JSON.stringify(updates)));

      // Determine inviter candidate
      let inviter = null;
      if (inviterUID) {
        try {
          const inviterSnap = await firebase.database.ref(`/user/${inviterUID}`).once('value');
          inviter = inviterSnap.val() || null;
        } catch (_) { inviter = null; }
      }
      // Fallback 1: appOwner in /user for same company
      if (!inviter) {
        try {
          const ownersSnap = await firebase.database.ref('user').orderByChild('appOwner').equalTo(true).once('value');
          const owners = ownersSnap.val() || {};
          for (const key in owners) {
            const o = owners[key];
            if (o && o.companyID === companyID) { inviter = o; break; }
          }
        } catch (_) {}
      }
      // Fallback 2: first/earliest company user from /users
      if (!inviter) {
        try {
          const compSnap = await firebase.database.ref('users').orderByChild('companyID').equalTo(companyID).once('value');
          const compUsers = compSnap.val() || {};
          let best = null;
          Object.keys(compUsers).forEach(k => {
            const u = compUsers[k];
            if (!best) { best = u; }
            else {
              const a = typeof u.userType === 'number' ? u.userType : 99;
              const b = typeof best.userType === 'number' ? best.userType : 99;
              if (a < b) best = u; // prefer smaller (admin) userType
              else if (a === b) {
                if ((u.dateRegistered || 0) < (best.dateRegistered || Number.MAX_SAFE_INTEGER)) best = u;
              }
            }
          });
          inviter = best;
        } catch (_) {}
      }

      // Auto-follow if we have inviter data and user has userID
      if (inviter && inviter.userID && user && user.userID) {
        const followDate = Date.now();
        const theirdata = {
          firstName: inviter.firstName || inviter.userName || '',
          lastName: inviter.lastName || '',
          companyName: inviter.companyName || '',
          dateRegistered: followDate,
          photoURL: inviter.photoURL || '',
          userID: inviter.userID
        };
        const mydata = {
          firstName: user.firstName || user.userName || '',
          lastName: user.lastName || '',
          companyName: user.companyName || '',
          dateRegistered: followDate,
          photoURL: user.photoURL || '',
          userID: user.userID
        };
        const fu = {};
        fu[`users/${user.userID}/following/${inviter.userID}`] = theirdata;
        fu[`users/${inviter.userID}/follower/${user.userID}`] = mydata;
        fu[`followers/${inviter.userID}/${user.userID}`] = mydata;
        try { console.log('[INVITE] writing follow edges', { follower: user.userID, followee: inviter.userID }); } catch (_) {}
        await firebase.database.ref().update(JSON.parse(JSON.stringify(fu)));
      }

      // Clear invite so it is used once
      try { localStorage.removeItem('INVITE_DATA'); console.log('[INVITE] consumed'); } catch (_) {}
    } catch (e) {
      try { console.log('[INVITE] error', e && e.message ? e.message : e); } catch (_) {}
    }
  };
};
// Check if user has WhatsApp OTP enabled
export const checkUserWhatsAppOTPSettings = (email) => {
  return async (dispatch, getState) => {
    try {
      // Search for user by email in Firebase
      const usersRef = firebase.database.ref('/user');
      const snapshot = await usersRef.orderByChild('email').equalTo(email).once('value');
      
      if (snapshot.exists()) {
        const users = snapshot.val();
        const userKey = Object.keys(users)[0];
        const user = users[userKey];
        
        // Check if user has WhatsApp OTP enabled AND has a phone number
        const hasWhatsAppOTP = user.receiveWhatsAppSecurity === true;
        const hasPhoneNumber = user.cellphone && user.cellphone.trim() !== '';
        const securityLevel = user.defaultSecurityLevel || 'level1';
        

        
        // For Level 2 & Level 3: Must have both WhatsApp OTP enabled AND valid phone number
        // For Level 1: WhatsApp OTP should be disabled
        if ((securityLevel === 'level2' || securityLevel === 'level3') && hasWhatsAppOTP && hasPhoneNumber) {
          return {
            requiresOTP: true,
            phoneNumber: formatPhoneNumber(user.cellphone),
            userID: user.userID || userKey,
            securityLevel: securityLevel
          };
        } else if (securityLevel === 'level1') {
          // Level 1 should not require OTP
          return {
            requiresOTP: false,
            securityLevel: securityLevel,
            reason: 'LEVEL_1_NO_OTP'
          };
        } else if ((securityLevel === 'level2' || securityLevel === 'level3') && !hasPhoneNumber) {
          // Level 2/3 but no phone number - should fallback to Level 1
          return {
            requiresOTP: false,
            securityLevel: 'level1',
            reason: 'NO_PHONE_NUMBER',
            needsPhoneNumber: true
          };
        } else if ((securityLevel === 'level2' || securityLevel === 'level3') && !hasWhatsAppOTP) {
          // Level 2/3 but WhatsApp OTP not enabled - enable it if user has phone
          if (hasPhoneNumber) {
            // Auto-enable WhatsApp OTP for Level 2/3 users with phone numbers
            const updates = {
              receiveWhatsAppSecurity: true,
              lastSecurityUpdate: Date.now()
            };
            
            await firebase.database.ref(`/user/${userKey}`).update(updates);
            
            return {
              requiresOTP: true,
              phoneNumber: formatPhoneNumber(user.cellphone),
              userID: user.userID || userKey,
              securityLevel: securityLevel,
              autoEnabled: true
            };
          } else {
            return {
              requiresOTP: false,
              securityLevel: 'level1',
              reason: 'NO_PHONE_NUMBER',
              needsPhoneNumber: true
            };
          }
        }
      }
      
      return { 
        requiresOTP: false, 
        securityLevel: 'level1',
        reason: 'USER_NOT_FOUND'
      };
    } catch (error) {
      return { 
        requiresOTP: false, 
        securityLevel: 'level1',
        reason: 'ERROR'
      };
    }
  };
};

// Direct login without OTP (for users who haven't enabled WhatsApp OTP)
// export const signInWithEmailAndPasswordDirect = (credentials) => {
//   return async (dispatch, getState) => {
//     try {
//       const email = credentials.email || credentials.username;
//       const password = credentials.password || credentials.userpassword;

//       // Use await fully — no .then()
//       const auth = await firebase.auth.signInWithEmailAndPassword(email, password);

//       const userobj = {
//         uid: auth.user.uid,
//         displayName: auth.user.displayName,
//         email: auth.user.email,
//         emailVerified: auth.user.emailVerified,
//         refreshToken: auth.user.refreshToken,
//         metadata: auth.user.metadata,
//         selectClub: auth.user.selectClub,
//         companyID: getCompanyID(auth.user.email)
//       };

//       let userLoginData = {
//         uid: auth.user.uid,
//         name: auth.user.displayName,
//         email: auth.user.email,
//         dateRegistered: Date.now(),
//         clickType: 'lastlogin'
//       };

//       localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj));

//       const snapshot = await firebase.database.ref(`/user/${userobj.uid}`).once('value');
//       let isUser = snapshot.val();

//       if (isUser) {
//         await firebase.database.ref('user-lastlogin').push(userLoginData);
//         dispatch(authStateChanged(userobj));
//       } else {
//         // New user creation logic
//         let timeInMs = Date.now();
//         let datetime = new Date(timeInMs);
//         datetime = DATE_FORMAT.type(datetime, 'BADGE');

//         let userID = firebase.database.ref().child('users').push().key;

//         var data = {
//           dateRegistered: timeInMs,
//           email: auth.user.email,
//           firstName: auth.user.displayName || '',
//           lastName: '',
//           password: '',
//           stringDateRegistered: datetime,
//           userDescription: 'Public Contributor',
//           uid: auth.user.uid,
//           userID: userID,
//           userType: 3,
//           inviteSent: true,
//           companyID_userType: auth.user.selectClub + '_3',
//           photoURL: auth.user.photoURL || ''
//         };

//         let updates = {};
//         updates['/users/' + userID] = data;
//         updates['/user/' + auth.user.uid] = data;

//         await firebase.database.ref().update(updates);
//         await firebase.database.ref('user-lastlogin').push(userLoginData);
//         dispatch(authStateChanged(userobj));
//       }

//       return { success: true, message: 'Login successful' };

//     } catch (error) {
//       console.error('Login error:', error);

//       // Clean up on error
//       localStorage.removeItem(USER_LOGGED_IN);
//       localStorage.removeItem(GLP_LOGGED_PROFILE);
//       localStorage.removeItem(GLP_LOGGED_COMPANY);

//       let errorMessage = 'Login failed. Please try again.';
//       if (error.code) {
//         switch (error.code) {
//           case 'auth/user-not-found':
//             errorMessage = 'No account found with this email address.';
//             break;
//           case 'auth/wrong-password':
//             errorMessage = 'Incorrect password.';
//             break;
//           case 'auth/invalid-email':
//             errorMessage = 'Invalid email address.';
//             break;
//           case 'auth/too-many-requests':
//             errorMessage = 'Too many failed attempts. Try again later.';
//             break;
//           default:
//             errorMessage = error.message || errorMessage;
//         }
//       }

//       dispatch({
//         type: SHOW_TOAST,
//         variant: ERROR,
//         message: errorMessage
//       });

//       return { success: false, error: errorMessage };
//     }
//   };
// };

export const signInWithEmailAndPasswordDirect = (credentials) => {
  return async (dispatch, getState) => {
    console.log('[signInEmailEnhanced] 1.4:', credentials);
    console.log('signInDirect: localStorage pendingLinkToken =', localStorage.getItem('pendingLinkToken'));
    try {
      const email = credentials.email || credentials.username;
      const password = credentials.password || credentials.userpassword;
      
    await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);
    await firebase.auth.signInWithEmailAndPassword(email, password)
        .then(auth => {
          const userobj = {
            uid: auth.user.uid,
            displayName: auth.user.displayName,
            email: auth.user.email,
            emailVerified: auth.user.emailVerified,
            refreshToken: auth.user.refreshToken,
            metadata: auth.user.metadata,
            selectClub: auth.user.selectClub,
            companyID: getCompanyID(auth.user.email)
          }

          let userLoginData = {
            uid: auth.user.uid,
            name: auth.user.displayName,
            email: auth.user.email,
            dateRegistered: Date.now(),
            clickType: 'lastlogin'
          }

          localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj))

          firebase.database
            .ref(`/user/${userobj.uid}`)
            .once('value')
            .then(data => {
              let isUser = data.val()

            if (isUser) {
              firebase.database.ref('user-lastlogin').push(userLoginData)
              dispatch(authStateChanged(userobj))

              // ---- Telegram account linking ----
              const pendingToken = localStorage.getItem("pendingLinkToken")
              || new URLSearchParams(window.location.search).get("linkToken");
              //console.log('signInDirect: pendingToken =', pendingToken);

              //console.log('signInDirect: pendingToken FINAL =', pendingToken);
              //console.log('signInDirect: FB_URL =', FB_URL);
              //console.log('signInDirect: full URL will be =', `${FB_URL}/m126-completeTelegramLink`);

              if (pendingToken) {
                localStorage.removeItem("pendingLinkToken");
                axios.post(`${FB_URL}/m126-completeTelegramLink`, {
                  token: pendingToken,
                  firebaseUid: auth.user.uid,
                })
                .then(linkRes => {
                  if (linkRes.data?.success) {
                    console.log('Telegram account linked successfully');
                  } else {
                    console.error('Telegram link error:', linkRes.data);
                  }
                })
                .catch(err => console.error('Telegram link failed:', err));
              }
              // ----------------------------------
            } else {
                // Handle new user creation (same as original logic)
                let timeInMs = Date.now()
                let datetime = new Date(timeInMs)
                datetime = DATE_FORMAT.type(datetime, 'BADGE')

                let userID = firebase.database
                  .ref()
                  .child('users')
                  .push().key
                var data = {
                  dateRegistered: timeInMs,
                  email: auth.user.email,
                  firstName: auth.user.displayName,
                  lastName: '',
                  password: '',
                  stringDateRegistered: datetime,
                  userDescription: 'Public Contributor',
                  uid: auth.user.uid,
                  userID: userID,
                  userType: 3,
                  inviteSent: true,
                  companyID_userType: auth.user.selectClub + '_3',
                  photoURL: auth.user.photoURL
                }

                let updates = {}
                updates['/users/' + userID] = data
                updates['/user/' + auth.user.uid] = data

                firebase.database.ref().update(updates, function (error) {
                  if (error) {
                    firebase.auth.signOut().then(() => {
                      localStorage.removeItem(USER_LOGGED_IN)
                      localStorage.removeItem(GLP_LOGGED_PROFILE)
                      localStorage.removeItem(GLP_LOGGED_COMPANY)
                      sessionStorage.removeItem('reAuthRequired');
                      sessionStorage.removeItem('cachedTotpSecret');                   
                      dispatch({
                        type: SHOW_TOAST,
                        variant: ERROR,
                        message: error.message
                      })
                    })
                  } else {
                    firebase.database.ref('user-lastlogin').push(userLoginData)
                    dispatch(authStateChanged(userobj))
                  }
                })
              }
            })
            .catch(function (error) {
              firebase.auth.signOut().then(() => {
                localStorage.removeItem(USER_LOGGED_IN)
                localStorage.removeItem(GLP_LOGGED_PROFILE)
                localStorage.removeItem(GLP_LOGGED_COMPANY)
                sessionStorage.removeItem('reAuthRequired');
                sessionStorage.removeItem('cachedTotpSecret');
                dispatch({
                  type: SHOW_TOAST,
                  variant: ERROR,
                  message: error.message
                })
              })
            })
        })
        .catch(err => {
          localStorage.removeItem(USER_LOGGED_IN)
          dispatch({ type: SHOW_TOAST, variant: ERROR, message: err.message })
        })
      
      return { success: true, message: 'Login successful' };
      
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: error.message || 'Login failed. Please try again.'
      });
      return { success: false, error: error.message };
    }
  };
};

// WhatsApp OTP Functions for Login

export const getUserPhoneNumber = (email) => {
  return async (dispatch, getState) => {
    try {
      // Search for user by email in Firebase
      const usersRef = firebase.database.ref('/user');
      const snapshot = await usersRef.orderByChild('email').equalTo(email).once('value');
      
      if (snapshot.exists()) {
        const users = snapshot.val();
        const userKey = Object.keys(users)[0];
        const user = users[userKey];
        
        if (user.cellphone) {
          const formattedPhone = formatPhoneNumber(user.cellphone);
          return {
            success: true,
            phoneNumber: formattedPhone.success ? formattedPhone.phoneNumber : user.cellphone
          };
        }
      }
      
      return {
        success: false,
        error: 'No phone number found for this user'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  };
};

// WhatsApp OTP Lockout Management
export const checkOTPLockoutStatus = (phoneNumber) => {
  return async (dispatch, getState) => {
    try {
      const lockoutKey = phoneNumber.replace(/\+/g, '').replace(/\D/g, '');
      const lockoutRef = firebase.database.ref(`/whatsapp_otp_lockouts/${lockoutKey}`);
      const snapshot = await lockoutRef.once('value');
      
      if (snapshot.exists()) {
        const lockoutData = snapshot.val();
        const now = Date.now();
        
        // Check if lockout period has expired
        if (lockoutData.lockedUntil && now < lockoutData.lockedUntil) {
          const remainingTime = Math.ceil((lockoutData.lockedUntil - now) / (1000 * 60)); // minutes
          
          // Check for escalation (multiple lockouts)
          const lockoutCount = lockoutData.lockoutCount || 1;
          const needsEscalation = lockoutCount >= 3; // Escalate after 3 lockouts
          
          return {
            isLocked: true,
            remainingMinutes: remainingTime,
            failedAttempts: lockoutData.failedAttempts || 0,
            lockoutReason: lockoutData.lockoutReason || 'UNKNOWN',
            lockoutCount: lockoutCount,
            needsEscalation: needsEscalation
          };
        } else if (lockoutData.lockedUntil && now >= lockoutData.lockedUntil) {
          // Lockout period expired, but keep lockout count for escalation tracking
          const lockoutCount = lockoutData.lockoutCount || 0;
          await lockoutRef.update({
            lockedUntil: null,
            failedAttempts: 0,
            lockoutReason: null,
            lastLockoutExpired: now,
            // Keep lockoutCount for escalation tracking
            lockoutCount: lockoutCount
          });
          return { 
            isLocked: false, 
            failedAttempts: 0,
            lockoutCount: lockoutCount,
            needsEscalation: lockoutCount >= 3
          };
        }
        
        // User has failed attempts but not locked yet
        const lockoutCount = lockoutData.lockoutCount || 0;
        return {
          isLocked: false,
          failedAttempts: lockoutData.failedAttempts || 0,
          lockoutReason: lockoutData.lockoutReason || 'UNKNOWN',
          lockoutCount: lockoutCount,
          needsEscalation: lockoutCount >= 3
        };
      }
      
      return { isLocked: false, failedAttempts: 0, lockoutCount: 0, needsEscalation: false };
    } catch (error) {
      return { isLocked: false, failedAttempts: 0, lockoutCount: 0, needsEscalation: false };
    }
  };
};

export const recordFailedOTPAttempt = (phoneNumber) => {
  return async (dispatch, getState) => {
    try {
      const lockoutKey = phoneNumber.replace(/\+/g, '').replace(/\D/g, '');
      const lockoutRef = firebase.database.ref(`/whatsapp_otp_lockouts/${lockoutKey}`);
      const snapshot = await lockoutRef.once('value');
      
      let failedAttempts = 1;
      let lockoutData = {
        phoneNumber: phoneNumber,
        firstFailedAttempt: Date.now(),
        lastFailedAttempt: Date.now(),
        failedAttempts: 1,
        lockoutReason: 'OTP_VERIFICATION_FAILED', // Track the specific reason
        lockoutCount: 0 // Initialize lockout count
      };
      
      if (snapshot.exists()) {
        const existingData = snapshot.val();
        failedAttempts = (existingData.failedAttempts || 0) + 1;
        lockoutData = {
          ...existingData,
          lastFailedAttempt: Date.now(),
          failedAttempts: failedAttempts,
          lockoutReason: 'OTP_VERIFICATION_FAILED'
        };
      }
      
      // Lock user for 30 minutes after 3 failed attempts
      if (failedAttempts >= 3) {
        const lockoutDuration = 30 * 60 * 1000; // 30 minutes in milliseconds
        const currentLockoutCount = (lockoutData.lockoutCount || 0) + 1; // Increment lockout count
        
        lockoutData.lockedUntil = Date.now() + lockoutDuration;
        lockoutData.lockedAt = Date.now();
        lockoutData.lockoutReason = 'OTP_VERIFICATION_FAILED';
        lockoutData.lockoutCount = currentLockoutCount; // Track how many times user has been locked
        
        await lockoutRef.set(lockoutData);
        
        // Check if escalation is needed (3 or more lockouts)
        if (currentLockoutCount >= 3) {
          dispatch({
            type: SHOW_TOAST,
            variant: ERROR,
            message: `🚨 SECURITY ESCALATION REQUIRED\n\nThis account has been locked ${currentLockoutCount} times. For security reasons, you need to use the Account Recovery process.\n\nPlease visit the Account Recovery page to regain access or contact support.`
          });
          
          return {
            isLocked: true,
            failedAttempts: failedAttempts,
            remainingMinutes: 30,
            lockoutReason: 'OTP_VERIFICATION_FAILED',
            lockoutCount: currentLockoutCount,
            needsEscalation: true
          };
        } else {
          dispatch({
            type: SHOW_TOAST,
            variant: ERROR,
            message: `🔒 Account locked for 30 minutes due to 3 failed WhatsApp OTP verification attempts. (Lockout #${currentLockoutCount})`
          });
          
          return {
            isLocked: true,
            failedAttempts: failedAttempts,
            remainingMinutes: 30,
            lockoutReason: 'OTP_VERIFICATION_FAILED',
            lockoutCount: currentLockoutCount,
            needsEscalation: false
          };
        }
      } else {
        await lockoutRef.set(lockoutData);
        
        const remainingAttempts = 3 - failedAttempts;
        dispatch({
          type: SHOW_TOAST,
          variant: WARNING,
          message: `Invalid WhatsApp OTP. ${remainingAttempts} attempt${remainingAttempts !== 1 ? 's' : ''} remaining before 30-minute lockout.`
        });
        
        return {
          isLocked: false,
          failedAttempts: failedAttempts,
          remainingAttempts: remainingAttempts,
          lockoutReason: 'OTP_VERIFICATION_FAILED',
          lockoutCount: lockoutData.lockoutCount || 0,
          needsEscalation: false
        };
      }
    } catch (error) {
      return { isLocked: false, failedAttempts: 0, lockoutCount: 0, needsEscalation: false };
    }
  };
};

export const clearOTPLockout = (phoneNumber) => {
  return async (dispatch, getState) => {
    try {
      const lockoutKey = phoneNumber.replace(/\+/g, '').replace(/\D/g, '');
      const lockoutRef = firebase.database.ref(`/whatsapp_otp_lockouts/${lockoutKey}`);
      
      // Get current data first to check if lockout count should be reset
      const snapshot = await lockoutRef.once('value');
      
      if (snapshot.exists()) {
        // OTP was correct - reset everything including lockout count

        await lockoutRef.remove();
        
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: '✅ Login successful! All security lockouts have been reset.',
          pos: 'bottom'
        });
      } else {
        // No lockout data exists, just remove it
        await lockoutRef.remove();
      }
      
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  };
};

export const sendWhatsAppOTPForLogin = (phoneNumber) => {
  return async (dispatch, getState) => {
    try {
      // Check lockout status before sending OTP
      const lockoutStatus = await dispatch(checkOTPLockoutStatus(phoneNumber));
      
      if (lockoutStatus.isLocked) {
        const lockoutReason = lockoutStatus.lockoutReason || 'OTP_VERIFICATION_FAILED';
        let lockoutMessage = '';
        
        switch (lockoutReason) {
          case 'OTP_VERIFICATION_FAILED':
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nYou entered an incorrect WhatsApp OTP 3 times. This is a security measure to protect your account.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nThe lockout will automatically expire and you can try again.`;
            break;
          case 'RATE_LIMITED':
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nToo many verification requests were sent. Twilio rate limit exceeded.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nPlease wait for the lockout to expire.`;
            break;
          default:
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nMultiple failed login attempts detected.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nPlease contact support if this continues.`;
        }
        
        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: lockoutMessage
        });
        return { 
          success: false, 
          error: 'Account locked',
          isLocked: true,
          remainingMinutes: lockoutStatus.remainingMinutes,
          lockoutReason: lockoutReason
        };
      }
      
      // Validate phone number format
      if (!validatePhoneNumber(phoneNumber)) {
        throw new Error('Invalid phone number format. Please contact support.');
      }
      
      // Use new Twilio Verify service (now with rate limit handling)
      const whatsappResult = await sendWhatsAppOTPService(phoneNumber);
      
      if (!whatsappResult.success) {
        // Handle Twilio rate limiting specifically
        if (whatsappResult.isRateLimited) {
          dispatch({
            type: SHOW_TOAST,
            variant: WARNING,
            message: 'Too many verification attempts. Please wait 10 minutes and try again.'
          });
          return { 
            success: false, 
            error: 'Rate limited by Twilio',
            isRateLimited: true
          };
        }
        
        throw new Error(whatsappResult.error || 'Failed to send WhatsApp message');
      }
      
      // Store verification info for later (using Twilio's verification SID)
      const verificationData = {
        phoneNumber: phoneNumber,
        verificationSid: whatsappResult.verificationSid,
        timestamp: Date.now(),
        expires: Date.now() + (5 * 60 * 1000), // 5 minutes
        verified: false,
        failedAttempts: lockoutStatus.failedAttempts || 0
      };
      
      await firebase.database.ref(`/whatsapp_login_verifications/${phoneNumber.replace(/\+/g, '').replace(/\D/g, '')}`).set(verificationData);
      
      let message = `OTP sent to ${phoneNumber}. Check your WhatsApp.`;
      if (lockoutStatus.failedAttempts > 0) {
        const remainingAttempts = 3 - lockoutStatus.failedAttempts;
        message += ` (${remainingAttempts} attempts remaining before lockout)`;
      }
      
      dispatch({
        type: SHOW_TOAST,
        variant: 'success',
        message: message
      });
      
      return { success: true, message: 'WhatsApp OTP sent successfully' };
      
    } catch (error) {
      
      // Check if it's a rate limit error in the catch block too
      if (error.message && (error.message.includes('60204') || error.message.includes('Max send attempts reached'))) {
        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: 'Too many verification attempts. Please wait 10 minutes and try again.'
        });
        return { 
          success: false, 
          error: 'Rate limited',
          isRateLimited: true
        };
      }
      
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: 'Failed to send WhatsApp OTP. Please try again in a few minutes.'
      });
      return { success: false, error: error.message };
    }
  };
};

export const verifyWhatsAppOTPAndLogin = (credentials) => {
  return async (dispatch, getState) => {
    try {
      // Check for development bypass
      if (credentials.bypassVerification && process.env.NODE_ENV === 'development') {
        // Get stored credentials from sessionStorage
        const tempCredentials = JSON.parse(sessionStorage.getItem('tempLoginCredentials') || '{}');
        const email = credentials.email || tempCredentials.email;
        const password = credentials.password || tempCredentials.password;
        
        // Clear temporary credentials
        sessionStorage.removeItem('tempLoginCredentials');
        
        // Complete login directly
        await firebase.auth.signInWithEmailAndPassword(email, password);
        
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: 'Development bypass - Login successful!'
        });
        
        return { success: true, message: 'Development bypass login successful' };
      }
      
      // Normal OTP verification continues below...
      // Get stored credentials from sessionStorage
      const tempCredentials = JSON.parse(sessionStorage.getItem('tempLoginCredentials') || '{}');
      const email = credentials.email || tempCredentials.email;
      const password = credentials.password || tempCredentials.password;
      const phoneNumber = tempCredentials.phoneNumber;
      
      if (!phoneNumber) {
        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: 'Phone number not found. Please try logging in again.'
        });
        return { success: false, error: 'Phone number not found' };
      }
      
      // Check lockout status before verifying OTP
      const lockoutStatus = await dispatch(checkOTPLockoutStatus(phoneNumber));
      
      if (lockoutStatus.isLocked) {
        const lockoutReason = lockoutStatus.lockoutReason || 'OTP_VERIFICATION_FAILED';
        let lockoutMessage = '';
        
        switch (lockoutReason) {
          case 'OTP_VERIFICATION_FAILED':
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nYou entered an incorrect WhatsApp OTP 3 times. This is a security measure to protect your account.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nThe lockout will automatically expire and you can try again.`;
            break;
          case 'RATE_LIMITED':
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nToo many verification requests were sent. Twilio rate limit exceeded.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nPlease wait for the lockout to expire.`;
            break;
          default:
            lockoutMessage = `🔒 ACCOUNT LOCKED FOR 30 MINUTES\n\nMultiple failed login attempts detected.\n\n⏰ Time Remaining: ${lockoutStatus.remainingMinutes} minute${lockoutStatus.remainingMinutes !== 1 ? 's' : ''}\n\nPlease contact support if this continues.`;
        }
        
        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: lockoutMessage
        });
        return { 
          success: false, 
          error: 'Account locked',
          isLocked: true,
          remainingMinutes: lockoutStatus.remainingMinutes,
          lockoutReason: lockoutReason
        };
      }
      
      // Import the new verification service
      //const { verifyWhatsAppOTPCode } = require('../../services/whatsappService');
      
      // Use Twilio Verify service to check the OTP
      const verificationResult = await verifyWhatsAppOTPCode(phoneNumber, credentials.otp);
      
      if (!verificationResult.success) {
        // Record failed attempt and check if user should be locked
        const failureResult = await dispatch(recordFailedOTPAttempt(phoneNumber));
        
        if (failureResult.isLocked) {
          return { 
            success: false, 
            error: 'Account locked due to too many failed attempts',
            isLocked: true,
            remainingMinutes: failureResult.remainingMinutes,
            lockoutCount: failureResult.lockoutCount,
            needsEscalation: failureResult.needsEscalation
          };
        }
        
        return { 
          success: false, 
          error: verificationResult.message || 'Invalid OTP',
          failedAttempts: failureResult.failedAttempts,
          remainingAttempts: failureResult.remainingAttempts,
          lockoutCount: failureResult.lockoutCount,
          needsEscalation: failureResult.needsEscalation
        };
      }
      
      // OTP verified successfully - clear any lockout data
      await dispatch(clearOTPLockout(phoneNumber));
      
      // Clean up verification data from Firebase
      const verificationRef = firebase.database.ref(`/whatsapp_login_verifications/${phoneNumber.replace(/\+/g, '').replace(/\D/g, '')}`);
      await verificationRef.remove();
      
      // Clear temporary credentials
      sessionStorage.removeItem('tempLoginCredentials');
      
      // Now complete the login process
      await firebase.auth.signInWithEmailAndPassword(email, password)
        .then((auth) => {
          const userobj = {
            uid: auth.user.uid,
            displayName: auth.user.displayName,
            email: auth.user.email,
            emailVerified: auth.user.emailVerified,
            refreshToken: auth.user.refreshToken,
            metadata: auth.user.metadata,
            selectClub: auth.user.selectClub,
            companyID: getCompanyID(auth.user.email)
          }
          
          let userLoginData = {
            uid: auth.user.uid,
            name: auth.user.displayName,
            email: auth.user.email,
            dateRegistered: Date.now(),
            clickType: 'lastlogin'
          }
          
          localStorage.setItem(USER_LOGGED_IN, JSON.stringify(userobj))
          
          firebase.database
            .ref(`/user/${userobj.uid}`)
            .once('value')
            .then(data => {
              let isUser = data.val()
              
              if (isUser) {
                firebase.database.ref('user-lastlogin').push(userLoginData)
                dispatch(authStateChanged(userobj))
              } else {
                // Handle new user creation (same as original logic)
                let timeInMs = Date.now()
                let datetime = new Date(timeInMs)
                datetime = DATE_FORMAT.type(datetime, 'BADGE')

                let userID = firebase.database
                  .ref()
                  .child('users')
                  .push().key
                var data = {
                  dateRegistered: timeInMs,
                  email: auth.user.email,
                  firstName: auth.user.displayName,
                  lastName: '',
                  password: '',
                  stringDateRegistered: datetime,
                  userDescription: 'Public Contributor',
                  uid: auth.user.uid,
                  userID: userID,
                  userType: 3,
                  inviteSent: true,
                  companyID_userType: auth.user.selectClub + '_3',
                  photoURL: auth.user.photoURL
                }

                let updates = {}
                updates['/users/' + userID] = data
                updates['/user/' + auth.user.uid] = data

                firebase.database.ref().update(updates, function (error) {
                  if (error) {
                    firebase.auth.signOut().then(() => {
                      localStorage.removeItem(USER_LOGGED_IN)
                      localStorage.removeItem(GLP_LOGGED_PROFILE)
                      localStorage.removeItem(GLP_LOGGED_COMPANY)
                      sessionStorage.removeItem('reAuthRequired');
                      sessionStorage.removeItem('cachedTotpSecret');

                      dispatch({
                        type: SHOW_TOAST,
                        variant: ERROR,
                        message: error.message
                      })
                    })
                  } else {
                    firebase.database.ref('user-lastlogin').push(userLoginData)
                    dispatch(authStateChanged(userobj))
                  }
                })
              }
            })
            .catch(function (error) {
              firebase.auth.signOut().then(() => {
                localStorage.removeItem(USER_LOGGED_IN)
                localStorage.removeItem(GLP_LOGGED_PROFILE)
                localStorage.removeItem(GLP_LOGGED_COMPANY)
                sessionStorage.removeItem('reAuthRequired');
                sessionStorage.removeItem('cachedTotpSecret');
                dispatch({
                  type: SHOW_TOAST,
                  variant: ERROR,
                  message: error.message
                })
              })
            })
        })
        .catch(err => {
          localStorage.removeItem(USER_LOGGED_IN)
          dispatch({ type: SHOW_TOAST, variant: ERROR, message: err.message })
        })
      
      dispatch({
        type: SHOW_TOAST,
        variant: 'success',
        message: 'Login successful! Welcome back.'
      });
      
      return { success: true, message: 'Login successful' };
      
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: 'Failed to verify OTP. Please try again.'
      });
      return { success: false, error: error.message };
    }
  };
};

export const signOut = () => {
  let updates = {};
  const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));
  const uid = userData.uid; // Make sure UID is stored
 console.log('enforceSingleSession signOut');
  return async(dispatch, getState) => {
    // 🔥 Clear uniqueSession
    updates[`user/${uid}/uniqueSession`] = null;
      var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                  updates: updates, //user wallet address                       
              }
            })

        if (res.data || res.data.success === true) {
          firebase.auth.signOut().then(() => {
            localStorage.removeItem(USER_LOGGED_IN)
            localStorage.removeItem(GLP_LOGGED_PROFILE)
            localStorage.removeItem(GLP_LOGGED_COMPANY)
            localStorage.removeItem('pledgeconfirmed');
            sessionStorage.removeItem('reAuthRequired');
            sessionStorage.removeItem('cachedTotpSecret');

            delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
            dispatch({ type: SIGNOUT_SUCCESS })
          })  
          dispatch({ type: SIGNOUT_SUCCESS })            }
        else {
         // console.error('Error signing out duplicate user:', error);
          dispatch({ type: FAIL })
        }; 

    firebase.auth.signOut().then(() => {
      localStorage.removeItem(USER_LOGGED_IN)
      localStorage.removeItem(GLP_LOGGED_PROFILE)
      localStorage.removeItem(GLP_LOGGED_COMPANY)
      localStorage.removeItem('pledgeconfirmed');
      sessionStorage.removeItem('reAuthRequired');
      sessionStorage.removeItem('cachedTotpSecret');
      //unlock buy/sell tokens button///////////////
      //sessionStorage.removeItem("buyCoinsRan");

      // Update MEVSession only if userData exists
      // if (userData?.uid) {
      //   updates[`/user/${userData.uid}/MEVSession`] = true;
        
      //   // ✅ FIX: Corrected the database reference
      //   firebase.database.ref().update(updates);
      // }

      delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
      dispatch({ type: SIGNOUT_SUCCESS })
    })
  }
}

export const signOutStrong = () => {
  let updates = {};
  const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));

  return (dispatch, getState) => {
   firebase.auth.signOut().then(() => {
      localStorage.removeItem(USER_LOGGED_IN)
      localStorage.removeItem(GLP_LOGGED_PROFILE)
      localStorage.removeItem(GLP_LOGGED_COMPANY)
      localStorage.removeItem('pledgeconfirmed');
      sessionStorage.removeItem('reAuthRequired');
      sessionStorage.removeItem('cachedTotpSecret');

      console.log('signOut data 1: ', userData);
      // === BACKEND CALL - FIRE AND FORGET ===
     
      const myemail = userData.email;
      const uid = userData.uid;
      const safeEmail = myemail.replace(/\./g, '_');  // Replace all dots with underscores
 
      updates[`user/${uid}/uniqueSession`] = null;
      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: myemail,  // Keep the original email for reference
        status: false
      };

       axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
              }
         })
        .then(res => {
          //console.log('signOut data 2: : saved', res.data);
           delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
           dispatch({ type: SIGNOUT_SUCCESS })
        })
        .catch(err => {
         // console.error('signOut data 3:  failed:', err);
          dispatch({ type: fail })
        });

      delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
      dispatch({ type: SIGNOUT_SUCCESS })
    })
  }
}

// export const signOutStrong = () => {
//   return async (dispatch) => {
//     const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));
//     console.log('enforceSingleSession signOutStrong 1', userData);
//     if (!userData) return;
//     console.log('enforceSingleSession signOutStrong 2');
//     const uid = userData.uid; // Make sure UID is stored
//     let updates = {};
//  console.log('enforceSingleSession signOutStrong 3', uid);
//     // 🔥 Clear uniqueSession
//     updates[`user/${uid}/uniqueSession`] = null;

//     try {
//       // // Clear session in DB FIRST
//       //        var res = await axios.post(`${FB_URL}/m115-freshcard`, {
//       //               params: {
//       //                    updates: updates, //user wallet address                       
//       //                }
//       //              })
 
//       //          if (res.data || res.data.success === true) {
//       //            console.log('Successfully signed out');   
//       //            console.log('enforceSingleSession signOutStrong 3a', uid);            }
//       //          else {
//       //            console.error('Error signing out duplicate user:');
//       //             console.log('enforceSingleSession signOutStrong 3b');
//       //          }; 
//  console.log('enforceSingleSession signOutStrong 4');
//       await firebase.auth().signOut();
//  console.log('enforceSingleSession signOutStrong 4a');
//       localStorage.removeItem(USER_LOGGED_IN);
//       localStorage.removeItem(GLP_LOGGED_PROFILE);
//       localStorage.removeItem(GLP_LOGGED_COMPANY);
//       localStorage.removeItem('pledgeconfirmed');
//       localStorage.removeItem('uniqueSession');
// console.log('enforceSingleSession signOutStrong 5');
//       delete axios.defaults.headers.common['Authorization'];

//       dispatch({ type: SIGNOUT_SUCCESS });

//       console.log("Strong signout completed");

//     } catch (err) {
//       console.error("enforceSingleSession Strong signout failed:", err);
//     }
//   };
// };

export const signOutDuplicate = () => {
  let updates = {};
  const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));
 console.log('enforceSingleSession signOutDuplicate');
  return (dispatch, getState) => {
   firebase.auth.signOut().then(() => {
      localStorage.removeItem(USER_LOGGED_IN)
      localStorage.removeItem(GLP_LOGGED_PROFILE)
      localStorage.removeItem(GLP_LOGGED_COMPANY)
      localStorage.removeItem('pledgeconfirmed');
      sessionStorage.removeItem('reAuthRequired');
      sessionStorage.removeItem('cachedTotpSecret');

      console.log('signOut data 1: ', userData);
      // === BACKEND CALL - FIRE AND FORGET ===
     
      const myemail = userData.email;
      const safeEmail = myemail.replace(/\./g, '_');  // Replace all dots with underscores

      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: myemail,  // Keep the original email for reference
        status: false
      };

      delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
      dispatch({ type: SIGNOUT_SUCCESS })
    })
  }
}


export const signOutStrong_16Feb = () => {
  let updates = {};
  const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));

  return (dispatch, getState) => {
   firebase.auth.signOut().then(() => {
      localStorage.removeItem(USER_LOGGED_IN)
      localStorage.removeItem(GLP_LOGGED_PROFILE)
      localStorage.removeItem(GLP_LOGGED_COMPANY)
      localStorage.removeItem('pledgeconfirmed');

      console.log('signOut data 1: ', userData);
      // === BACKEND CALL - FIRE AND FORGET ===
     
      const myemail = userData.email;
      const safeEmail = myemail.replace(/\./g, '_');  // Replace all dots with underscores

      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: myemail,  // Keep the original email for reference
        status: false
      };

       axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
              }
         })
        .then(res => {
          console.log('signOut data 2: : saved', res.data);
        })
        .catch(err => {
          console.error('signOut data 3:  failed:', err);
        });

      delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
      dispatch({ type: SIGNOUT_SUCCESS })
    })
  }
}

export const signOutStrong_primary = () => {
  let updates = {};
  const userData = JSON.parse(localStorage.getItem(USER_LOGGED_IN));

  return (dispatch, getState) => {
    firebase.auth.signOut().then(() => {
      localStorage.removeItem(USER_LOGGED_IN)
      localStorage.removeItem(GLP_LOGGED_PROFILE)
      localStorage.removeItem(GLP_LOGGED_COMPANY)
      localStorage.removeItem('pledgeconfirmed');
      sessionStorage.removeItem('reAuthRequired');
      sessionStorage.removeItem('cachedTotpSecret');
      console.log('signOut data: ', userData);
      // === BACKEND CALL - FIRE AND FORGET ===
     
      const myemail = userData.email;
      const safeEmail = myemail.replace(/\./g, '_');  // Replace all dots with underscores

      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: myemail,  // Keep the original email for reference
        status: false
      };

       axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
              }
         })
        .then(res => {
          console.log('emailconfirmations: saved', res.data);
        })
        .catch(err => {
          console.error('Backend save failed:', err);
        });
      //unlock buy/sell tokens button///////////////
      //sessionStorage.removeItem("buyCoinsRan");

      // Update MEVSession only if userData exists
      // if (userData?.uid) {
      //   updates[`/user/${userData.uid}/MEVSession`] = true;
        
      //   // ✅ FIX: Corrected the database reference
      //   firebase.database.ref().update(updates);
      // }

      delete axios.defaults.headers.common['Authorization']; //new line to secure login uid
      dispatch({ type: SIGNOUT_SUCCESS })
    })
  }
}

// Export the flags so App.js can check them
export const getIsValidatingCredentials = () => isValidatingCredentials;
export const getIsGoogleAuthInProgress = () => isGoogleAuthInProgress;
export const getGoogleAuthMode = () => googleAuthMode;

// Function to manually clear Twilio rate limits (for development/testing)
export const clearTwilioRateLimitForPhone = (phoneNumber) => {
  return async (dispatch, getState) => {
    try {
      const result = await clearTwilioRateLimit(phoneNumber);
      
      if (result.success) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: 'Rate limits cleared. You can try sending OTP again.'
        });
      } else {
        dispatch({
          type: SHOW_TOAST,
          variant: WARNING,
          message: 'Could not clear rate limits. Please wait 10 minutes.'
        });
      }
      
      return result;
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: 'Failed to clear rate limits.'
      });
      return { success: false, error: error.message };
    }
  };
};

// Function to manually clear all lockouts (for development/testing)
export const clearAllLockoutsForUser = (email) => {
  return async (dispatch, getState) => {
    try {
      // First, get the user's phone number
      const usersRef = firebase.database.ref('/user');
      const snapshot = await usersRef.orderByChild('email').equalTo(email).once('value');
      
      let phoneNumber = "+27123456789"; // Default fallback
      
      if (snapshot.exists()) {
        const users = snapshot.val();
        const userKey = Object.keys(users)[0];
        const user = users[userKey];
        if (user.cellphone) {
          phoneNumber = formatPhoneNumber(user.cellphone);
        }
      }
      
      // Clear OTP lockouts
      const lockoutKey = phoneNumber.replace(/\+/g, '').replace(/\D/g, '');
      const lockoutRef = firebase.database.ref(`/whatsapp_otp_lockouts/${lockoutKey}`);
      await lockoutRef.remove();
      
      // Clear verification data
      const verificationRef = firebase.database.ref(`/whatsapp_login_verifications/${lockoutKey}`);
      await verificationRef.remove();
      
      // Clear temporary credentials
      sessionStorage.removeItem('tempLoginCredentials');
      
      // Clear Twilio rate limits
      await clearTwilioRateLimit(phoneNumber);
      
      dispatch({
        type: SHOW_TOAST,
        variant: 'success',
        message: '🔧 All lockouts cleared! You can try logging in again.'
      });
      
      return { success: true, phoneNumber: phoneNumber };
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: 'Failed to clear lockouts. Please refresh the page.'
      });
      return { success: false, error: error.message };
    }
  };
};

// Check lockout status by email (converts email to phone number first)
export const checkOTPLockoutStatusByEmail = (email) => {
  return async (dispatch, getState) => {
    try {
      // First get the user's phone number from email
      const usersRef = firebase.database.ref('/user');
      const snapshot = await usersRef.orderByChild('email').equalTo(email).once('value');
      
      if (!snapshot.exists()) {
        return { isLocked: false, failedAttempts: 0 };
      }
      
      const users = snapshot.val();
      const userKey = Object.keys(users)[0];
      const user = users[userKey];
      
      if (!user.cellphone) {
        return { isLocked: false, failedAttempts: 0 };
      }
      
      const phoneNumber = formatPhoneNumber(user.cellphone);
      
      // Now check lockout status for this phone number
      return await dispatch(checkOTPLockoutStatus(phoneNumber));
    } catch (error) {
      return { isLocked: false, failedAttempts: 0 };
    }
  };
};

// Email verification bypass for escalated lockout users
export const sendEmailVerificationBypass = (email) => {
  return async (dispatch, getState) => {
    try {
      // Generate a verification token
      const verificationToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      const expiresAt = Date.now() + (30 * 60 * 1000); // 30 minutes
      
      // Store verification token in Firebase
      const verificationRef = firebase.database.ref(`/email_verification_bypass/${email.replace(/\./g, '_')}`);
      await verificationRef.set({
        email: email,
        verificationToken: verificationToken,
        createdAt: Date.now(),
        expiresAt: expiresAt,
        verified: false,
        reason: 'LOCKOUT_ESCALATION'
      });
      
      // In a real implementation, you would send this via email service
      // For now, we'll show it in a toast (development only)
      dispatch({
        type: SHOW_TOAST,
        variant: INFO,
        message: `📧 Email verification sent to ${email}. Check your email for verification instructions.`
      });
      
      // In production, you would call your email service here:
      // await sendEmailService({
      //   to: email,
      //   subject: 'Account Verification Required - Security Lockout',
      //   template: 'lockout-escalation',
      //   data: { verificationToken, email }
      // });
      
      return { 
        success: true, 
        message: 'Email verification sent',
        verificationToken: verificationToken // Remove this in production
      };
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: 'Failed to send email verification. Please contact support.'
      });
      return { success: false, error: error.message };
    }
  };
};

// Verify email bypass token
export const verifyEmailBypassToken = (email, token) => {
  return async (dispatch, getState) => {
    try {
      // This is a placeholder implementation for email verification
      // In a real implementation, you would validate the token server-side
      
      if (!token || token.length < 10) {
        throw new Error('Invalid verification token');
      }
      
      // For development/testing, accept any token with "BYPASS" in it
      if (token.includes('BYPASS') || token.includes('TEST')) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: '✅ Email verification successful! Account access restored.'
        });
        
        return { success: true };
      }
      
      // Check if token matches expected format (could be more sophisticated)
      const expectedTokenPattern = /^[A-Za-z0-9]{10,}$/;
      if (expectedTokenPattern.test(token)) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: '✅ Email verification successful! Account access restored.'
        });
        
        return { success: true };
      }
      
      throw new Error('Invalid verification token');
      
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: `❌ Email verification failed: ${error.message}`
      });
      return { success: false, error: error.message };
    }
  };
};

// ============================================================================
// DEVICE TRUST MANAGEMENT ACTIONS
// ============================================================================

/**
 * Check if current device is trusted for a user
 * @param {string} userEmail - User's email address
 * @returns {object} - Device trust status
 */
export const checkDeviceTrustStatus = (userEmail) => {
  return async (dispatch, getState) => {
    try {
  
      const trustStatus = await checkDeviceTrust(userEmail);
      
      
      return trustStatus;
      
    } catch (error) {
      return {
        isTrusted: false,
        isNewDevice: true,
        error: error.message
      };
    }
  };
};

/**
 * Add current device to trusted list after successful OTP verification
 * @param {string} userEmail - User's email address
 * @param {object} additionalInfo - Additional device information
 * @returns {boolean} - Success status
 */
export const addDeviceToTrustedList = (userEmail, additionalInfo = {}) => {
  return async (dispatch, getState) => {
    try {

      
      const success = await trustDevice(userEmail, null, {
        loginTimestamp: Date.now(),
        ...additionalInfo
      });
      
      if (success) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: '📱 Device trusted! OTP will only be required once a week on this device.',
          pos: 'bottom'
        });
        

        return { success: true };
      } else {
        throw new Error('Failed to trust device');
      }
      
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: WARNING,
        message: '⚠️ Could not save device trust status. OTP may be required on next login.'
      });
      return { success: false, error: error.message };
    }
  };
};

/**
 * Update device last used timestamp
 * @param {string} userEmail - User's email address
 * @returns {boolean} - Success status
 */
export const updateTrustedDeviceUsage = (userEmail) => {
  return async (dispatch, getState) => {
    try {

      return await updateDeviceLastUsed(userEmail);
    } catch (error) {
      return false;
    }
  };
};

/**
 * Remove device from trusted list
 * @param {string} userEmail - User's email address
 * @param {string} deviceId - Optional device ID to remove (defaults to current device)
 * @returns {boolean} - Success status
 */
export const removeDeviceFromTrustedList = (userEmail, deviceId = null) => {
  return async (dispatch, getState) => {
    try {

      
      const success = await untrustDevice(userEmail, deviceId);
      
      if (success) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'info',
          message: '📱 Device removed from trusted list. OTP will be required on next login.',
          pos: 'bottom'
        });
        
        
        return { success: true };
      } else {
        throw new Error('Failed to remove device from trusted list');
      }
      
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: WARNING,
        message: '⚠️ Could not remove device from trusted list.'
      });
      return { success: false, error: error.message };
    }
  };
};

// In authActions.js
export const checkEmailConfirmationStatus = (email) => {
  return async () => {
    if (!email) return false;

    const safeEmail = email.replace(/\./g, '_');
    const ref = firebase.database.ref(`/emailconfirmations/${safeEmail}`);

    try {
      const snapshot = await ref.once('value');
      if (snapshot.exists()) {
        const data = snapshot.val();
        // Optional: add timestamp check for freshness
        const isRecent = Date.now() - data.timestamp < 10 * 60 * 1000; // 10 minutes
        return data.status === true && isRecent;
      }
      return false;
    } catch (error) {
      console.error('Error checking email confirmation:', error);
      return false;
    }
  };
};

// export const signInWithEmailAndPasswordEnhanced = credentials => {
//   return async (dispatch, getState) => {
//     try {
//       const email = credentials.email || credentials.username;
//       const password = credentials.password || credentials.userpassword;

//       if (!email || !password) {
//         throw new Error('Missing email or password');
//       }

//       console.log('[Login] Attempting sign-in for:', email);

//       // === STEP 1: AUTHENTICATE ===
//       let authResult;
//       try {
//         authResult = await firebase.auth().signInWithEmailAndPassword(email, password);
//       } catch (authError) {
//         let msg = 'Login failed.';
//         switch (authError.code) {
//           case 'auth/user-not-found':
//             msg = 'No account found with this email.';
//             break;
//           case 'auth/wrong-password':
//             msg = 'Incorrect password.';
//             break;
//           case 'auth/invalid-email':
//             msg = 'Invalid email format.';
//             break;
//           case 'auth/user-disabled':
//             msg = 'Account disabled.';
//             break;
//           case 'auth/too-many-requests':
//             msg = 'Too many attempts. Try again later.';
//             break;
//         }

//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: msg
//         });

//         return { success: false, error: msg };
//       }

//       const user = authResult.user;

//       // === STEP 2: EMAIL VERIFICATION ===
//       if (!user.emailVerified) {
//         await firebase.auth().signOut();

//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Please verify your email before logging in.'
//         });

//         return {
//           success: false,
//           error: 'EMAIL_NOT_VERIFIED'
//         };
//       }

//       // === STEP 3: LOAD PROFILE ===
//       const uid = user.uid;
//       const profileSnap = await firebase.database().ref(`/user/${uid}`).once('value');

//       if (!profileSnap.exists()) {
//         await firebase.auth().signOut();

//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Account profile not found. Please complete signup.'
//         });

//         return {
//           success: false,
//           error: 'PROFILE_NOT_FOUND'
//         };
//       }

//       const profile = profileSnap.val();
//       const securityLevel = profile.defaultSecurityLevel === 'level2' ? 'level2' : 'level1';
//       const hasTOTP = profile.totpEnabled === true && !!profile.totpSecret;

//       console.log('[Login] securityLevel:', securityLevel, 'TOTP:', hasTOTP);

//       // === STEP 4: ENFORCE TOTP ===
//       if (securityLevel === 'level2') {
//         await firebase.auth().signOut();

//         sessionStorage.setItem(
//           'tempLoginCredentials',
//           JSON.stringify({ email, password })
//         );

//         return {
//           success: true,
//           requiresOTP: true,
//           method: 'TOTP'
//         };
//       }

//       // === STEP 5: FINAL LOGIN ===
//       return await dispatch(signInWithEmailAndPasswordDirect(credentials));

//     } catch (error) {
//       console.error('[Login] Fatal error:', error);

//       dispatch({
//         type: SHOW_TOAST,
//         variant: ERROR,
//         message: error.message || 'Login failed.'
//       });

//       return { success: false, error: error.message };
//     }
//   };
// };

export const signInWithEmailAndPasswordEnhanced = credentials => {
  return async (dispatch, getState) => {
    // Check if OTP is provided (second step of login)
    if (credentials.otp) {
      // Verify TOTP and complete login
      return await dispatch(verifyTOTPAndLogin(credentials));
    }
    
    try {
      const email = credentials.email || credentials.username;
      const password = credentials.password || credentials.userpassword;
      // IMPORTANT: Security level MUST be read from Firebase user profile only.
      // Ignore any client-provided securityLevel to avoid bypass.
      console.log('[signInEmailEnhanced] Login attempt. Email:', email);

      // STEP 1: Validate email/password AND check TOTP status while authenticated
      let authResult = null;
      let profileSecurityLevel = null; // 'level1' | 'level2'
      let hasTOTPConfigured = false;
      console.log('[signInEmailEnhanced] 1:', credentials);

    try {
     isValidatingCredentials = true;
      await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);  // ← ADD
       authResult = await firebase.auth.signInWithEmailAndPassword(email, password);
     console.log('[signInEmailEnhanced] 2:');   
        // STEP 2: While authenticated, read required security level and TOTP configuration from user profile
        const uid = authResult.user.uid;
        const userRef = firebase.database.ref(`/user/${uid}`);
        const snapshot = await userRef.once('value');
 console.log('[signInEmailEnhanced] 3:');       
        if (snapshot.exists()) {
          const user = snapshot.val();
          // Strictly derive security level from profile only
          const rawLevel = user.defaultSecurityLevel;
 console.log('[signInEmailEnhanced] 4:');         
          profileSecurityLevel = rawLevel === 'level2' ? 'level2' : 'level1';
          hasTOTPConfigured = user.totpEnabled === true && !!user.totpSecret;
          console.log('[signInEmailEnhanced] Profile securityLevel:', profileSecurityLevel, 'hasTOTPConfigured:', hasTOTPConfigured);
        } else {
          // No profile found → block login (do not fallback)
 console.log('[signInEmailEnhanced] 5:');      

          isValidatingCredentials = false;
          await firebase.auth.signOut();
          sessionStorage.removeItem('reAuthRequired');
          sessionStorage.removeItem('cachedTotpSecret');
          dispatch({
            type: SHOW_TOAST,
            variant: ERROR,
            message: 'Account profile not found. Please contact support.'
          });
          return { success: false, error: 'PROFILE_NOT_FOUND' };
        }


        // === EMAIL CONFIRMATION CHECK === COMMENT OUT LOCAL HOST
         const confirmationStatus = await dispatch(checkEmailConfirmationStatus(email));

         if (confirmationStatus !== true) {
          await firebase.auth.signOut();
          sessionStorage.removeItem('reAuthRequired');
          sessionStorage.removeItem('cachedTotpSecret');
          isValidatingCredentials = false;

          dispatch({
            type: SHOW_TOAST,
            variant: ERROR,
            message: 'Please confirm your email by clicking the link sent to your inbox before logging in.'
          });

          return {
            success: false,
            error: 'EMAIL_NOT_CONFIRMED',
            message: 'Email confirmation required'
          };
         }

        console.log('[signInEmailEnhanced] Email confirmed — proceeding with login');
        // ===============================

        // Sign out immediately to prevent dashboard flash
        await firebase.auth.signOut();
        sessionStorage.removeItem('reAuthRequired');
        sessionStorage.removeItem('cachedTotpSecret');
        isValidatingCredentials = false;
        
      } catch (authError) {
        // Clear flag on error
        isValidatingCredentials = false;


        // Handle credential validation errors
        let errorMessage = 'Login failed. Please try again.';
        if (authError.code === 'auth/user-not-found') {
          errorMessage = 'No account found with this email address.';
        } else if (authError.code === 'auth/wrong-password') {
          errorMessage = 'Incorrect password. Please check your password and try again.';
        } else if (authError.code === 'auth/invalid-email') {
          errorMessage = 'Invalid email address format.';
        } else if (authError.code === 'auth/user-disabled') {
          errorMessage = 'This account has been disabled. Please contact support.';
        } else if (authError.code === 'auth/too-many-requests') {
          errorMessage = 'Too many failed login attempts. Please try again later.';
        } else if (authError.code === 'auth/invalid-credential') {
          errorMessage = 'Invalid email or password. Please check your credentials.';
        }

        dispatch({
          type: SHOW_TOAST,
          variant: ERROR,
          message: errorMessage
        });
        return { success: false, error: errorMessage };
      }

      // STEP 3: Enforce profile-required security level with no fallback

      if (profileSecurityLevel === 'level2') {
        console.log('[signInEmailEnhanced] securityLevel=level2 - requesting TOTP code for login');

        // Store credentials temporarily for TOTP verification step (do NOT store secret)
        const tempCredentials = {
          email: email,
          password: password,
          securityLevel: profileSecurityLevel
        };
        sessionStorage.setItem('tempLoginCredentials', JSON.stringify(tempCredentials));

        return { success: true, requiresOTP: true, method: 'TOTP', securityLevel: profileSecurityLevel };
      }

      console.log('[signInEmailEnhanced] securityLevel=level1 - proceeding with standard login', {
        securityLevel: profileSecurityLevel
      });
      return await dispatch(signInWithEmailAndPasswordDirect(credentials));
    } catch (error) {
      dispatch({
        type: SHOW_TOAST,
        variant: ERROR,
        message: error.message || 'Login failed. Please try again.'
      });
      return { success: false, error: error.message };
    }
  }
};
//////////////////////////////////////////////////////////////////////////////////
// Enhanced signInWithEmailAndPassword with device trust checking
// export const signInWithEmailAndPasswordEnhanced = credentials => {
//   return async (dispatch, getState) => {
//     // Check if OTP is provided (second step of login)
//     if (credentials.otp) {
//       // Verify TOTP and complete login
//       return await dispatch(verifyTOTPAndLogin(credentials));
//     }
    
//     try {
//       const email = credentials.email || credentials.username;
//       const password = credentials.password || credentials.userpassword;
//       // IMPORTANT: Security level MUST be read from Firebase user profile only.
//       // Ignore any client-provided securityLevel to avoid bypass.
//       console.log('[signInEmailEnhanced] Login attempt. Email:', email);

//       // STEP 1: Validate email/password AND check TOTP status while authenticated
//       let authResult = null;
//       let profileSecurityLevel = null; // 'level1' | 'level2'
//       let hasTOTPConfigured = false;
      
//       try {
//         isValidatingCredentials = true;
//         authResult = await firebase.auth.signInWithEmailAndPassword(email, password);
        
//         // STEP 2: While authenticated, read required security level and TOTP configuration from user profile
//         const uid = authResult.user.uid;
//         const userRef = firebase.database.ref(`/user/${uid}`);
//         const snapshot = await userRef.once('value');
        
//         if (snapshot.exists()) {
//           const user = snapshot.val();
//           // Strictly derive security level from profile only
//           const rawLevel = user.defaultSecurityLevel;
//           profileSecurityLevel = rawLevel === 'level2' ? 'level2' : 'level1';
//           hasTOTPConfigured = user.totpEnabled === true && !!user.totpSecret;
//           console.log('[signInEmailEnhanced] Profile securityLevel:', profileSecurityLevel, 'hasTOTPConfigured:', hasTOTPConfigured);
//         } else {
//           // No profile found → block login (do not fallback)
//           isValidatingCredentials = false;
//           await firebase.auth.signOut();
//           dispatch({
//             type: SHOW_TOAST,
//             variant: ERROR,
//             message: 'Account profile not found. Please contact support.'
//           });
//           return { success: false, error: 'PROFILE_NOT_FOUND' };
//         }
        
//         // Sign out immediately to prevent dashboard flash
//         await firebase.auth.signOut();
//         isValidatingCredentials = false;
        
//       } catch (authError) {
//         // Clear flag on error
//         isValidatingCredentials = false;

//         // Handle credential validation errors
//         let errorMessage = 'Login failed. Please try again.';
//         if (authError.code === 'auth/user-not-found') {
//           errorMessage = 'No account found with this email address.';
//         } else if (authError.code === 'auth/wrong-password') {
//           errorMessage = 'Incorrect password. Please check your password and try again.';
//         } else if (authError.code === 'auth/invalid-email') {
//           errorMessage = 'Invalid email address format.';
//         } else if (authError.code === 'auth/user-disabled') {
//           errorMessage = 'This account has been disabled. Please contact support.';
//         } else if (authError.code === 'auth/too-many-requests') {
//           errorMessage = 'Too many failed login attempts. Please try again later.';
//         } else if (authError.code === 'auth/invalid-credential') {
//           errorMessage = 'Invalid email or password. Please check your credentials.';
//         }

//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: errorMessage
//         });
//         return { success: false, error: errorMessage };
//       }

//       // STEP 3: Enforce profile-required security level with no fallback

//       // Require TOTP for level2 regardless of whether TOTP is currently configured.
//       // If not configured, the verify step will block with a clear message.
//       if (profileSecurityLevel === 'level2') {
//         console.log('[signInEmailEnhanced] securityLevel=level2 - requesting TOTP code for login');

//         // Store credentials temporarily for TOTP verification step (do NOT store secret)
//         const tempCredentials = {
//           email: email,
//           password: password,
//           securityLevel: profileSecurityLevel
//         };
//         sessionStorage.setItem('tempLoginCredentials', JSON.stringify(tempCredentials));

//         return { success: true, requiresOTP: true, method: 'TOTP', securityLevel: profileSecurityLevel };
//       }

//       console.log('[signInEmailEnhanced] securityLevel=level1 - proceeding with standard login', {
//         securityLevel: profileSecurityLevel
//       });
//       return await dispatch(signInWithEmailAndPasswordDirect(credentials));
//     } catch (error) {
//       dispatch({
//         type: SHOW_TOAST,
//         variant: ERROR,
//         message: error.message || 'Login failed. Please try again.'
//       });
//       return { success: false, error: error.message };
//     }
//   }
// };

/**
 * Verify Google Authenticator TOTP and complete login
 */

export const verifyTOTPAndLogin = (credentials) => {
  return async (dispatch, getState) => {
    try {
      const onStatus = credentials.onStatus || (() => {});

      const tempCredentials = JSON.parse(sessionStorage.getItem('tempLoginCredentials') || '{}');
      const email = credentials.email || tempCredentials.email;
      const password = credentials.password || tempCredentials.password;
      const otp = credentials.otp;

      // Development bypass
      if (process.env.NODE_ENV === 'development' && (otp === '123456' || otp === '1234')) {
        try {
          console.log('[verifyTOTPAndLogin] Development bypass active');
          sessionStorage.removeItem('tempLoginCredentials');
          const loginResult = await dispatch(signInWithEmailAndPasswordDirect({ email, password }));
          return loginResult;
        } catch (bypassError) {
          console.error('[verifyTOTPAndLogin] Development bypass failed:', bypassError);
        }
      }

      if (!email || !password || !otp) {
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Missing login or TOTP information. Please try logging in again.' });
        return { success: false, error: 'MISSING_DATA' };
      }

      // STEP 1: Temp sign-in
      onStatus('Step 1: signing in temporarily...');
      let tempAuth = null;
      try {
        tempAuth = await firebase.auth.signInWithEmailAndPassword(email, password);
        onStatus('Step 1 done.');
      } catch (authError) {
        onStatus('Step 1 FAILED: ' + authError.code);
        let errorMessage = 'Login failed. Please check your email and password.';
        if (authError.code === 'auth/user-not-found') errorMessage = 'No account found with this email address.';
        else if (authError.code === 'auth/wrong-password') errorMessage = 'Incorrect password. Please check your password and try again.';
        else if (authError.code === 'auth/too-many-requests') errorMessage = 'Too many failed login attempts. Please try again later.';
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: errorMessage });
        return { success: false, error: errorMessage };
      }

      const uid = tempAuth && tempAuth.user ? tempAuth.user.uid : null;
      if (!uid) {
        onStatus('Step 1: no UID found.');
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Could not load account profile. Please try again.' });
        try { await firebase.auth.signOut(); } catch (_) {}
        return { success: false, error: 'NO_UID' };
      }

      // STEP 2: Database read
      onStatus('Step 2: connecting to database...');
      try {
        firebase.database.goOnline();
        // Give the connection a moment to establish on mobile
        await new Promise(resolve => setTimeout(resolve, 500));
      } catch (_) {}

      onStatus('Step 2: reading profile...');
      const userRef = firebase.database.ref(`/user/${uid}`);
      const snapshot = await userRef.once('value');
      onStatus('Step 2 done.');

      if (!snapshot.exists()) {
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Account profile not found. Please contact support.' });
        try { await firebase.auth.signOut(); } catch (_) {}
        return { success: false, error: 'PROFILE_NOT_FOUND' };
      }

      const user = snapshot.val();
      if (!user.totpEnabled || !user.totpSecret) {
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Google Authenticator (TOTP) is not configured for this account.' });
        return { success: false, error: 'TOTP_NOT_CONFIGURED' };
      }

      // STEP 3: TOTP verify (client-side, no network)
      onStatus('Step 3: verifying code...');
      const totp = new OTPAuth.TOTP({
        issuer: 'ThinkLead',
        label: email,
        algorithm: 'SHA1',
        digits: 6,
        period: 30,
        secret: OTPAuth.Secret.fromBase32(user.totpSecret)
      });
      const delta = totp.validate({ token: otp, window: 1 });
      onStatus('Step 3 done.');

      if (delta === null) {
        try { await firebase.auth.signOut(); } catch (_) {}
        dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Invalid TOTP code. Please enter the current code from Google Authenticator.' });
        return { success: false, error: 'INVALID_TOTP' };
      }

      sessionStorage.removeItem('tempLoginCredentials');

      // STEP 4: Sign out temp session
      onStatus('Step 4: signing out temp session...');
      try { await firebase.auth.signOut(); } catch (_) {}
      onStatus('Step 4 done.');

      // STEP 5: Real sign-in
      onStatus('Step 5: completing login...');
      const loginResult = await dispatch(signInWithEmailAndPasswordDirect({ email, password }));
      onStatus('Step 5 done — login complete!');

      if (loginResult && loginResult.success) {
        dispatch({ type: SHOW_TOAST, variant: 'success', message: 'Login successful!' });
      }

      return loginResult;

    } catch (error) {
      try { console.error('[verifyTOTPAndLogin] Error:', error && error.message ? error.message : error); } catch (_) {}
      dispatch({ type: SHOW_TOAST, variant: ERROR, message: 'Failed to verify TOTP. Please try again.' });
      return { success: false, error: error.message };
    }
  };
};

// export const verifyTOTPAndLogin = (credentials) => {
//   return async (dispatch, getState) => {
//     try {

//       // Load stored credentials from first step
//       const tempCredentials = JSON.parse(sessionStorage.getItem('tempLoginCredentials') || '{}');
//       const email = credentials.email || tempCredentials.email;
//       const password = credentials.password || tempCredentials.password;
//       const otp = credentials.otp;

//       // Development bypass for TOTP to simplify debugging and recovery
//       if (process.env.NODE_ENV === 'development' && (otp === '123456' || otp === '1234')) {
//         try {
//           console.log('[verifyTOTPAndLogin] Development bypass active - accepting test TOTP code');
//           sessionStorage.removeItem('tempLoginCredentials');
//           const loginResult = await dispatch(signInWithEmailAndPasswordDirect({ email, password }));
//           return loginResult;
//         } catch (bypassError) {
//           console.error('[verifyTOTPAndLogin] Development bypass failed:', bypassError);
//         }
//       }

//       if (!email || !password || !otp) {
//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Missing login or TOTP information. Please try logging in again.'
//         });
//         return { success: false, error: 'MISSING_DATA' };
//       }

//       // TEMP AUTH SIGN-IN:
//       // We must be authenticated to read `/user` due to Firebase rules (`auth != null`).
//       // Sign in with email/password, load the user's TOTP config, then sign out again
//       // before completing the "real" login via signInWithEmailAndPasswordDirect.
//       let tempAuth = null;
//       try {
//        // await firebase.auth.setPersistence(firebase.auth_.Auth.Persistence.LOCAL);
//         tempAuth = await firebase.auth.signInWithEmailAndPassword(email, password);
//       } catch (authError) {
//         // If credentials are wrong here, surface a clear error
//         let errorMessage = 'Login failed. Please check your email and password.';
//         if (authError.code === 'auth/user-not-found') {
//           errorMessage = 'No account found with this email address.';
//         } else if (authError.code === 'auth/wrong-password') {
//           errorMessage = 'Incorrect password. Please check your password and try again.';
//         } else if (authError.code === 'auth/too-many-requests') {
//           errorMessage = 'Too many failed login attempts. Please try again later.';
//         }

//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: errorMessage
//         });
//         return { success: false, error: errorMessage };
//       }

//       const uid = tempAuth && tempAuth.user ? tempAuth.user.uid : null;

//       if (!uid) {
//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Could not load account profile. Please try again.'
//         });
//         try { await firebase.auth.signOut(); 
//           sessionStorage.removeItem('reAuthRequired');
//           sessionStorage.removeItem('cachedTotpSecret');
//         } catch (_) {}
//         return { success: false, error: 'NO_UID' };
//       }

//       // Fetch user TOTP config from profile using authenticated read
//       const userRef = firebase.database.ref(`/user/${uid}`);
//       const snapshot = await userRef.once('value');

//       if (!snapshot.exists()) {
//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Account profile not found. Please contact support.'
//         });
//         try { await firebase.auth.signOut(); 
//           sessionStorage.removeItem('reAuthRequired');
//           sessionStorage.removeItem('cachedTotpSecret');
//         } catch (_) {}
//         return { success: false, error: 'PROFILE_NOT_FOUND' };
//       }

//       const user = snapshot.val();

//       if (!user.totpEnabled || !user.totpSecret) {
//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Google Authenticator (TOTP) is not configured for this account.'
//         });
//         return { success: false, error: 'TOTP_NOT_CONFIGURED' };
//       }

//       // Verify TOTP code
//       const totp = new OTPAuth.TOTP({
//         issuer: 'ThinkLead',
//         label: email,
//         algorithm: 'SHA1',
//         digits: 6,
//         period: 30,
//         secret: OTPAuth.Secret.fromBase32(user.totpSecret)
//       });

//       const delta = totp.validate({
//         token: otp,
//         window: 1
//       });

//       if (delta === null) {
//         // End the temporary auth session before returning
//         try { await firebase.auth.signOut(); 
//           sessionStorage.removeItem('reAuthRequired');
//           sessionStorage.removeItem('cachedTotpSecret');
//         } catch (_) {}
//         dispatch({
//           type: SHOW_TOAST,
//           variant: ERROR,
//           message: 'Invalid TOTP code. Please enter the current code from Google Authenticator.'
//         });
//         return { success: false, error: 'INVALID_TOTP' };
//       }

//       // Clear temporary credentials
//       sessionStorage.removeItem('tempLoginCredentials');

//       // End the temporary auth session before starting the "real" login
//       try { 
//         await firebase.auth.signOut();
//         // Do NOT clear reAuthRequired here — leave the guard intact until
//         // handleVerifyReAuthTOTP clears it after confirmed success
//       } catch (_) {}

//       // Complete login using direct email/password flow
//       const loginResult = await dispatch(signInWithEmailAndPasswordDirect({ email, password }));

//       if (loginResult && loginResult.success) {
//         dispatch({
//           type: SHOW_TOAST,
//           variant: 'success',
//           message: 'Login successful!'
//         });
//       }

//       return loginResult;

//     } catch (error) {
//       // Log full error details for troubleshooting
//       try {
//         console.error('[verifyTOTPAndLogin] Error verifying TOTP:', error && error.message ? error.message : error);
//       } catch (_) {}
//       dispatch({
//         type: SHOW_TOAST,
//         variant: ERROR,
//         message: 'Failed to verify TOTP. Please try again.'
//       });
//       return { success: false, error: error.message };
//     }
//   };
// };